const optimizationFeatures = [
  { icon: "ri-smartphone-line", title: "9:16 세로 형식", desc: "스마트 크롭을 활용한 지능형 리프레이밍 — 피사체를 중앙에 유지하고 핵심 액션을 화면에 담습니다." },
  { icon: "ri-closed-captioning-line", title: "자동 자막 생성", desc: "Whisper 기반 텍스트 변환에 플랫폼별 이모지 강조 캡션 스타일을 적용합니다." },
  { icon: "ri-hook-line", title: "훅 최적화", desc: "스크롤을 멈추는 첫 1~3초를 AI가 설계하여 끝까지 시청률을 극대화합니다." },
  { icon: "ri-scissors-2-line", title: "스마트 분할", desc: "긴 하이라이트를 내러티브 연속성을 유지하며 복수의 플랫폼 최적화 클립으로 자동 분할합니다." },
];

const platforms = [
  { name: "TikTok", maxDuration: "60초", format: "9:16", icon: "ri-tiktok-fill", color: "#10B981" },
  { name: "YouTube Shorts", maxDuration: "60초", format: "9:16", icon: "ri-youtube-fill", color: "#EF4444" },
  { name: "Instagram Reels", maxDuration: "90초", format: "9:16", icon: "ri-instagram-fill", color: "#F59E0B" },
];

export default function ShortFormSection() {
  return (
    <section className="py-28 bg-[#0F1419] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-[#F59E0B]/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#F59E0B] text-xs font-semibold uppercase tracking-widest mb-4 block" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            04 / 숏폼 최적화
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <span className="text-[#F59E0B]">숏폼 시대</span>를 위해 설계됨
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            모든 클립은 최대 바이럴 효과를 위해 설계됩니다. 화면 비율부터 캡션 스타일, 훅 타이밍까지
            AI가 각 플랫폼에 맞게 모든 프레임을 최적화합니다.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-72 bg-[#1A1F2E] border-2 border-white/10 rounded-[3rem] p-3 shadow-2xl">
                <div className="bg-[#0A0E14] rounded-[2.5rem] overflow-hidden" style={{ aspectRatio: "9/16" }}>
                  <div className="relative w-full h-full">
                    <img
                      src="https://public.readdy.ai/ai/img_res/26a30a1b146175a4c41d24047aa511f1.jpg"
                      alt="숏폼 세로 영상 미리보기"
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                    <div className="absolute bottom-16 left-0 right-0 px-4">
                      <div className="bg-black/60 backdrop-blur-sm rounded-xl px-4 py-2 text-center">
                        <p className="text-white text-sm font-bold leading-snug" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                          제가 그 종교에서 <span className="text-[#00D9FF]">빠져나올 수 있었던 이유는요...</span>
                        </p>
                      </div>
                    </div>
                    <div className="absolute top-4 right-4 flex flex-col gap-2">
                      {platforms.map((p) => (
                        <div key={p.name} className="w-7 h-7 flex items-center justify-center rounded-full" style={{ backgroundColor: `${p.color}20`, border: `1px solid ${p.color}40` }}>
                          <i className={`${p.icon} text-xs`} style={{ color: p.color }} />
                        </div>
                      ))}
                    </div>
                    <div className="absolute top-4 left-4 bg-[#F59E0B]/90 text-black text-xs font-bold px-2.5 py-1 rounded-full">
                      훅 0-3초
                    </div>
                    <div className="absolute bottom-4 left-4 right-4 flex justify-between items-center">
                      <span className="text-white/60 text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>0:14</span>
                      <span className="flex items-center gap-1 bg-[#10B981]/20 border border-[#10B981]/30 text-[#10B981] text-xs px-2.5 py-0.5 rounded-full">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse inline-block" />
                        AI 최적화
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -right-12 top-1/4 bg-[#0A0E14] border border-white/10 rounded-xl p-3 shadow-xl">
                <div className="text-xs text-gray-500 mb-1">시청 완료율</div>
                <div className="text-[#10B981] font-bold text-lg" style={{ fontFamily: "'JetBrains Mono', monospace" }}>94.2%</div>
              </div>
              <div className="absolute -left-14 top-1/2 bg-[#0A0E14] border border-white/10 rounded-xl p-3 shadow-xl">
                <div className="text-xs text-gray-500 mb-1">스크롤 정지율</div>
                <div className="text-[#F59E0B] font-bold text-lg" style={{ fontFamily: "'JetBrains Mono', monospace" }}>87.6%</div>
              </div>
            </div>
          </div>

          <div className="space-y-5">
            {optimizationFeatures.map((feat) => (
              <div key={feat.title} className="flex items-start gap-4 bg-[#0A0E14] border border-white/8 rounded-xl p-5 hover:border-[#F59E0B]/20 transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F59E0B]/10 rounded-xl shrink-0">
                  <i className={`${feat.icon} text-[#F59E0B] text-lg`} />
                </div>
                <div>
                  <div className="text-white font-semibold mb-1 text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{feat.title}</div>
                  <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{feat.desc}</p>
                </div>
              </div>
            ))}
            <div className="bg-[#0A0E14] border border-white/8 rounded-xl p-5">
              <div className="text-sm font-semibold text-gray-300 mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>플랫폼 사양</div>
              <div className="space-y-3">
                {platforms.map((p) => (
                  <div key={p.name} className="flex items-center justify-between">
                    <div className="flex items-center gap-2.5">
                      <span className="w-6 h-6 flex items-center justify-center">
                        <i className={`${p.icon} text-sm`} style={{ color: p.color }} />
                      </span>
                      <span className="text-gray-300 text-sm">{p.name}</span>
                    </div>
                    <div className="flex items-center gap-4 text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                      <span className="text-gray-600">최대 {p.maxDuration}</span>
                      <span className="text-gray-400">{p.format}</span>
                      <span className="text-[#10B981]">준비 완료</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
